// extracted by mini-css-extract-plugin
export var standaloneTable = "_23-0";
export var standaloneTableWithBodyFill = "_23-1";
export var withExtraHeader = "_23-2";